export const TOTAL_COUNT_MEETING = 'TOTAL_COUNT_MEETING';
export const REQUEST_API_START_MEETING = 'REQUEST_API_START_MEETING';
export const REQUEST_API_SUCCESS_MEETING = 'REQUEST_API_SUCCESS_MEETING';
export const REQUEST_API_ERROR_MEETING = 'REQUEST_API_ERROR_MEETING';
export const REQUEST_GET_MEETING_LIST_START = 'REQUEST_GET_MEETING_LIST_START';
export const REQUEST_GET_MEETING_LIST_SUCCESS = 'REQUEST_GET_MEETING_LIST_SUCCESS';
export const REQUEST_GET_MEETING_LIST_ERROR = 'REQUEST_GET_MEETING_LIST_ERROR';
export const REQUEST_GET_LIST_FILTER_MEETING_START = 'REQUEST_GET_LIST_FILTER_MEETING_START';
export const REQUEST_GET_LIST_FILTER_MEETING_SUCCESS = 'REQUEST_GET_LIST_FILTER_MEETING_SUCCESS';
export const REQUEST_GET_LIST_FILTER_MEETING_ERROR = 'REQUEST_GET_LIST_FILTER_MEETING_ERROR';
export const REQUEST_CREATE_MEETING = 'REQUEST_CREATE_MEETING';
export const REQUEST_UPDATE_BY_ID = 'REQUEST_UPDATE_BY_ID';
export const REQUEST_DELETE_BY_ID = 'REQUEST_DELETE_BY_ID';
export const REQUEST_MEMBER_MANAGERS = 'REQUEST_MEMBER_MANAGERS';
export const REQUEST_GET_MEMBER_LIST_SUCCESS = 'REQUEST_GET_MEMBER_LIST_SUCCESS';
